import React from 'react';
import { Zap } from '../../../../shared/assets/AppIcons';

export default function AutomationsHeader() {
  return (
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-2">
        <Zap className="text-[var(--warning-text)]" size={32} />
        <h1 className="text-4xl font-bold text-[var(--text-primary)]">Automazioni</h1>
      </div>
      <p className="text-[var(--text-secondary)]">
        Gestisci le tue automazioni attive e scopri nuove opportunita per risparmiare tempo
      </p>
    </div>
  );
}
